import { capitalize } from 'lodash';

/**
 * Get translated status
 * @param {string} status Raw status
 * @returns {string} Translated status
 */
export const translateStatus = status => {
  switch (status) {
    case 'OPEN':
      return 'Ouvert';
    case 'CLOSED':
      return 'Fermé';
    case 'WON':
      return 'Gagné';
    case 'LATE':
      return 'En retard';
    case 'CANCELLED':
      return 'Annulé';
    case 'LOST':
      return 'Perdu';
    default:
      return '';
  }
};

export const getBadgeColor = referer => {
  switch (referer) {
    case 'CAPIFRANCE':
      return 'capi';
    case 'OPTIMHOME':
      return 'oh';
    case 'DRIMKI':
      return 'drimki';
    case 'REFLEXIMMO':
      return 'reflex';
    case 'TVB':
    case 'TVB_RDV':
    case 'TVB_MOBILE':
      return 'tvb';
    default:
      return 'grey';
  }
};

export const getBadgeTitle = referer => {
  switch (referer) {
    case 'TVB':
      return 'Toutvabiens';
    case 'TVB_RDV':
      return 'Toutvabiens - RDV';
    case 'TVB_MOBILE':
      return 'Toutvabiens Mobile';
    default:
      return capitalize(referer);
  }
};

export const getAvailabilities = (availabilities = []) => {
  if (!availabilities) return '-';

  return availabilities
    .split(',')
    .map(availability => getAvailability(availability))
    .join(',');
};

const getAvailability = meet => {
  switch (meet) {
    case 'MORNING':
      return 'Matin';
    case 'NOON':
      return 'Midi';
    case 'AFTERNOON':
      return 'Aprés-midi';
    case 'EVENING':
      return 'Soir';
    default:
      return 'Toute la journée';
  }
};
